import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { withFormModel } from 'shared/hooks'
import { ServicesContext } from 'services/context'
import { spec, validators } from 'utils/validation'

import { toOptions } from 'routes/public/events/overview/components/filters/helpers'
import i18next from 'i18next'
import EditSponsorsFormComponent from './component'
import { toSponsorModel } from './mapping'

const { any, string } = validators

export const EditSponsorsForm = combine(
  withContext(
    'taxonomyService',
    ServicesContext,
    ({ taxonomyService }) => taxonomyService
  ),

  withContext(
    'adminSponsorsService',
    ServicesContext,
    ({ adminSponsorsService }) => adminSponsorsService
  ),

  withContext(
    'adminMemberService',
    ServicesContext,
    ({ adminMemberService }) => adminMemberService
  ),

  withFormModel(
    (_state, { initialValues = {} }) => {
      const formattedCountry = initialValues.address?.country
        ? { id: '', name: initialValues.address.country }
        : ''

      return {
        id: {
          initialValue: initialValues.id,
          spec: spec.flow(any.required),
        },

        sponsorFullName: {
          initialValue: initialValues.sponsorFullName || '',
          spec: spec.flow(any.required),
        },

        active: {
          initialValue: initialValues.active || false,
          spec: spec.flow(any.required),
        },

        email: {
          initialValue: initialValues.email || '',
          spec: spec.flow(any.required),
        },

        country: {
          alias: 'country',
          initialValue: formattedCountry,
          spec: spec.flow(),
        },

        website: {
          initialValue: initialValues.website || '',
          spec: spec.flow(string.isNotEmpty, any.required),
        },

        sponsorLimit: {
          initialValue: initialValues.sponsorLimit || '',
          spec: spec.flow(any.required),
        },

        taxId: {
          initialValue: initialValues.taxId || '',
          spec: spec.flow(any.required),
        },

        logo: {
          initialValue: initialValues.logo || '',
          spec: spec.flow(any.required),
        },

        marketingPromotion: {
          initialValue: initialValues.marketingPromotion || false,
          spec: spec.flow(any.required),
        },
      }
    },
    { id: 'sponsor-edit-form' }
  ),

  withCallbacks(
    {
      getOptionLabel:
        () =>
          ({ name }) =>
            name,
      getOptionValue:
        () =>
          ({ id }) =>
            id,

      loadJurisdictions:
        ({ taxonomyService }) =>
          (search = '') =>
            taxonomyService.queryJurisdictions({ search }),

      loadCategories: () => async () => {
        const sportTypes = toOptions(
          i18next.t('enum:sportType', { returnObjects: true })
        )
        return sportTypes
      },

      onSubmitRequest: {
        deps: ['onSubmit'],
        func:
          (_state, { onSubmit }) =>
            (form) => {
              const mappedData = toSponsorModel(form)
              const countryName = form.country ? form.country.name : undefined
              return onSubmit({
                ...mappedData,
                address: { country: countryName },
              })
            },
      },
    },
    []
  )
)(EditSponsorsFormComponent)
